import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer>
      <a href='#home' className='footer_logo'>Darius Williams — Cybersecurity Analyst</a>

      <ul className='permalinks'>
        <li><a href='#home'>Home</a></li>
        <li><a href='#about'>About</a></li>
        <li><a href='#accomplishments'>Experience</a></li>
        <li><a href='#credentials'>Credentials</a></li>
        <li><a href='#experience'>Skills</a></li>
        <li><a href='#portfolio'>Projects</a></li>
        <li><a href='#contact'>Contact</a></li>
      </ul>

      <div className='footer_copyright'>
        <small>&copy; Darius Williams. All rights reserved</small>
      </div>
    </footer>
  )
}

export default Footer;
